










import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import type { IImage } from '@getaccept/editor-lib';
import { ImageTransformHelper } from '@getaccept/editor-lib';

@Component
export default class ImageWithTransforms extends Vue {
  @Prop() image: IImage;
  @Prop() blockWidthClass: string;
  @Prop() isBlockToggled: boolean;
  @Watch('isBlockToggled')
  watchBlockToggle() {
    if (!this.isBlockToggled) {
      return;
    }
    this.handleImageLoaded();
  }
  @Prop() pageWidth: number;
  @Watch('pageWidth')
  watchPageWidth() {
    this.handleImageLoaded();
  }

  @Ref('inside') insideRef: HTMLDivElement;
  @Ref('container') containerRef: HTMLDivElement;

  @Watch('image.srcUrl', { immediate: true })
  loadImage() {
    this.imageLoadElement = new Image();
    this.imageLoadElement.onload = this.handleImageLoaded;
    this.imageLoadElement.src = this.image.srcUrl;
  }

  imageLoadElement: HTMLImageElement = null;

  get ratio() {
    return this.scale / 100;
  }

  get scale() {
    return this.image.imageTransforms?.scale || ImageTransformHelper.SCALE_MIN_VALUE;
  }

  get translateX() {
    return this.image.imageTransforms?.translateX || 0;
  }

  get translateY() {
    return this.image.imageTransforms?.translateY || 0;
  }

  async handleImageLoaded() {
    await Vue.nextTick();
    if (!this.containerRef) {
      return;
    }

    const { clientWidth: areaWidth, clientHeight: areaHeight } = this.containerRef;
    const { naturalWidth, naturalHeight } = this.imageLoadElement;

    if (!naturalWidth || !areaWidth) {
      return;
    }

    const [initialWidth, initialHeight] = ImageTransformHelper.getInitialImageSize(
      naturalWidth,
      naturalHeight,
      areaWidth,
      areaHeight
    );

    const transformOrigin = ImageTransformHelper.getTransformOrigin(
      initialHeight * this.ratio,
      initialWidth * this.ratio,
      areaHeight,
      areaWidth
    );

    this.insideRef.style.transformOrigin = transformOrigin;
    this.insideRef.style.backgroundImage = `url(${this.imageLoadElement.src})`;
    this.insideRef.style.width = `${initialWidth}px`;
    this.insideRef.style.height = `${initialHeight}px`;
  }

  @Watch('image.imageTransforms', { immediate: true })
  async watchImageTransforms() {
    await Vue.nextTick();
    if (!this.insideRef) {
      return;
    }

    const translateXCSS = `translateX(${this.translateX / this.ratio}%)`;
    const translateYCSS = `translateY(${this.translateY / this.ratio}%)`;

    this.insideRef.style.transform = `scale(${this.ratio}) ${translateXCSS} ${translateYCSS} translateZ(0)`;
  }
}
